<template>
  <div>
    <el-drawer :visible.sync="drawer" direction="rtl" size="50%" :modal-append-to-body="false" :before-close="onCancel">
      <BjDivider v-if="form">{{ form.id ? $t('billingPage.updateProfile') : $t('billingPage.createProfile') }}</BjDivider>
      <el-form v-if="drawer" ref="form" :model="form" :rules="rules" :disabled="disabled" label-width="200px">
        <el-form-item :label="$t('billingPage.profileTemplateName')+':'" prop="name">
          <BjInput v-model="form.name" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" style="width:100%" clearable />
        </el-form-item>
        <!-- <el-form-item :label="$t('billingPage.profileTemplateEnName')+':'" prop="enName">
          <BjInput v-model="form.enName" :placeholder="$t('inputText')" style="width:100%" clearable />
        </el-form-item> -->
        <el-form-item :label="$t('billingPage.description')+':'">
          <BjInput v-model="form.description" :placeholder="$t('inputText')" type="textarea" show-word-limit :maxlength="MAX_LENGTH.BILLMAX" style="width:100%" clearable />
        </el-form-item>
        <el-form-item :label="$t('billingPage.ChoseCategories')+':'">
          <el-button type="primary" class="main-btn" @click="choseCategories">{{ $t('billingPage.ChoseCategories') }}</el-button>
        </el-form-item>
        <div style="margin-top:10px;">
            <!-- <el-button type="primary" class="main-btn" @click="choseCategories">{{ $t('billingPage.ChoseCategories') }}</el-button> -->
            <div v-for="(item,index) in form.categoryCodes" v-show="item.billCategories.length>0" :key="index">
              <BjDivider>{{ item.group }}</BjDivider>
              <el-table ref="multipleTable" :data="item.billCategories" style="width: 100%" border>
                  <el-table-column prop="billCategoryName" :label="$t('billingPage.categoryName')" align="center"></el-table-column>
                  <el-table-column :label="$t('billingPage.Section')" align="center">
                    <template slot-scope="scope">
                      <span v-if="scope.row.sectionMin">
                        {{ scope.row.sectionMin }}{{ scope.row.unit }}<span v-if="scope.row.sectionMax">-{{ scope.row.sectionMax }}{{ scope.row.unit }}</span>
                      </span>
                      <span v-else>1</span>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('billingPage.standardPrice')" align="center">
                    <template slot-scope="scope">
                      <span v-if="scope.row.standardPrice">${{ scope.row.standardPrice }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('billingPage.Cost')" align="center">
                    <template slot-scope="scope">
                      <span v-if="scope.row.cost">${{ scope.row.cost }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="description" :label="$t('billingPage.description')" align="center"></el-table-column>
              </el-table>
            </div>
        </div>
        <div class="foot" style="margin-top: 10px;">
          <el-button type="danger" @click="onCancel">{{ $t('cancelText') }}</el-button>
          <el-button type="primary" @click="onComfirm">{{ $t('okText') }}</el-button>
        </div>
      </el-form>
    </el-drawer>
    <dialogData ref="dialogData" :table-list="tableList" @submit="onSubmit" @search="_getBillCategories" />
  </div>
</template>
<script>
import dialogData from './dialogData';
import { billApi } from '@/api';
export default {
  components: {
    dialogData
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      drawer: false,
      form: {
        id: null,
        name: '',
        enName: '',
        description: '',
        categoryCodes: [],
      },
      tableList: [],
      rules: {
         name: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        //  enName: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
      },
    };
  },
  methods: {
    _getBillCategories(val = '', name) {
      billApi.getBillCategories({keywords: val}).then(res => {
        if (name == 'create') {
          this.form.categoryCodes = res.data.map(item => {
            return { ...item, show: true, billCategories: [] };
          });
        }
        this.tableList = res.data.map(item => {
            return { ...item, show: true };
        });
      });
    },
    choseCategories() {
        this.$refs.dialogData.dialogVisible = true;
        this.$nextTick(() => {
          const categoryList = this.form.categoryCodes.map(item => {
            return item.billCategories.map(jitem => jitem.billCategoryCode);
          });
          this.$refs.dialogData.toggleSelection(categoryList.flat());
        });
    },
    hide() {
      this.drawer = false;
      this.from = {name: '', enName: '', description: '', categoryCodes: []};
    },
    /** 关闭弹窗 */
    /** 取消 */
    onCancel() {
      this.hide();
      this.$emit('close', true, this.form);
    },
    /** 确定 */
    onComfirm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          const categoryList = this.form.categoryCodes.map(item => {
            return item.billCategories.map(jitem => jitem.billCategoryCode);
          });
          const categoryCodes = categoryList.flat();
          if (categoryCodes.length == 0) return this.msgSuccess(this.$t('billingPage.ChoseCategories') + this.$t('emptyWarningText'));
          const obj = Object.assign({}, this.form, { categoryCodes });
          this.$emit('handleConfirm', obj);
          this.hide();
        }
      });
    },
    onSubmit(row) {
      this.form.categoryCodes = row;
    }
  },
};
</script>
<style lang="scss">
.flex-item {
  width: 200px;
  justify-content: space-between;
  align-items: flex-start;
}
.el-drawer__body {
  padding: 16px;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.el-form {
  flex: 1;
}
.foot {
  text-align: center;
  .el-button {
    width: 120px;
  }
}
</style>
